the_doc.ready( function() {
});

the_win.on( 'load', function( e ) {
});